import css from 'styled-jsx/css'


export default css.global`
  *,
  *:before,
  *:after {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
  }

  *:focus:not([keyboard-focus]) {
    outline: 0;
  }

  html,
  body {
    width: 100%;
  }

  html {
    font-size: 62.5%;
  }

  body {
    line-height: 1;
    overflow: initial;
    overflow-x: hidden;
    font-size: 1.6rem;
    font-family: 'Open Sans Regular', sans-serif;
  }

  .block-scroll {
    overflow-y: hidden;
  }
  
  h1 {
    font-weight: normal;
  }
  
  a,
  img,
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  picture,
  section {
    display: block;
  }

  ul,
  ol {
    list-style-type: none;
  }
`
